import React, { useEffect, useState } from "react";
import 'bootstrap/dist/css/bootstrap.min.css';

const departments = [
    {
        name: "परिचय",
        content: (
            <p>यहाँ विभाग के बारे में</p>
        )
    },
    { name: "संचालित पाठ्यक्रम", content: <p>यहाँ संचालित पाठ्यक्रम की जानकारी होगी।</p> },
    {
        name: "संकाय सदस्य",
        content: (
            <div className="mb-4">

                <div className="table-responsive">
                    <table className="table table-bordered table-striped table-hover align-middle">
                        <thead className="table-primary text-center">
                            <tr>
                                <th>फोटो</th>
                                <th>विभाग</th>
                                <th>आचार्य का नाम</th>
                                <th>पद</th>
                                <th>उच्चतम योग्यता</th>
                                <th>सम्पर्क</th>
                                <th>ई-मेल</th>
                            </tr>
                        </thead>
                        <tbody className="text-center">
                            <tr>
                                <td style={{ width: "140px" }}>
                                    <img
                                        src={require("../assets/Photos/डॉ कुलदीप सिंह (धर्मशास्त्र विभाग).jpeg")}
                                        alt="डॉ. कुलदीप सिंह"
                                        className="img-fluid rounded"
                                        style={{ height: "120px", objectFit: "cover" }}
                                    />
                                </td>
                                <td>धर्मशास्त्र विभाग</td>
                                <td>डॉ. कुलदीप सिंह</td>
                                <td>प्रभारी, सहायक-आचार्य</td>
                                <td>—</td>
                                <td>9248300000</td>
                                <td>
                                    <a href="mailto:hoddharamshastra@mvsu.ac.in">hoddharamshastra@mvsu.ac.in</a>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        )
    },

    { name: "समय सारिणी", content: <p>यहाँ समय सारिणी प्रदर्शित होगी।</p> },
    { name: "सुविधाएं", content: <p>यहाँ विभाग की सुविधाओं का विवरण होगा।</p> },
    { name: "सेमीनार/सम्मेलन/कार्यशाला", content: <p>यहाँ सेमीनार, सम्मेलन और कार्यशालाओं की जानकारी होगी।</p> },
    { name: "शोधच्छात्र", content: <p>यहाँ शोधछात्रों के बारे में जानकारी होगी।</p> },
    { name: "उपलब्धियां", content: <p>यहाँ विभाग की उपलब्धियों का विवरण होगा।</p> },
    { name: "संपर्क", content: <p>यहाँ संपर्क विवरण होगा।</p> },
];

export default function DepartmentDharmaStudies() {
    const [showSidebar, setShowSidebar] = useState(true);
    const [activeIndex, setActiveIndex] = useState(0);

    const handleItemClick = (index) => {
        setActiveIndex(index);
        if (window.innerWidth < 768) {
            setShowSidebar(false);
        }
    };

    return (
        <div className="d-flex vh-100 flex-column flex-md-row bg-light">
            {/* Small screen toggle button */}
            <button
                className="btn d-md-none m-2 shadow-sm text-white"
                onClick={() => setShowSidebar(!showSidebar)}
                style={{
                    backgroundColor: "#77236b",
                    borderColor: "#77236b"
                }}
            >
                ☰ मेनू
            </button>

            {/* Sidebar */}
            <aside
                className={`bg-white text-dark p-3 shadow-lg d-flex flex-column ${showSidebar ? "d-block" : "d-none"
                    } d-md-flex col-md-3 border-end`}
            >
                <h5 className="text-center fw-bold mb-4 text-dark border-bottom pb-2">
                    धर्मशास्त्र विभाग
                </h5>
                <div className="flex-grow-1 overflow-auto pe-2">
                    {departments.map((dept, index) => (
                        <p
                            key={index}
                            className={`mb-2 p-2 rounded small cursor-pointer shadow-sm ${activeIndex === index
                                ? "text-white"
                                : "bg-light text-dark hover-effect"
                                }`}
                            onClick={() => handleItemClick(index)}
                            style={{
                                cursor: "pointer",
                                transition: "background-color 0.3s ease, color 0.3s ease",
                                backgroundColor: activeIndex === index ? "#77236b" : undefined,
                                fontWeight: activeIndex === index ? "bold" : "normal"
                            }}
                        >
                            {dept.name}
                        </p>
                    ))}
                </div>
            </aside>

            {/* Content Area */}
            <main className="flex-grow-1 p-4 bg-white shadow col-md-9 overflow-auto">
                {departments[activeIndex].content}
            </main>

            {/* Custom Hover Effect */}
            <style jsx>{`
                .hover-effect:hover {
                    background-color: #e2e6ea !important;
                    color: #000 !important;
                }
            `}</style>
        </div>
    );
}